import styled from 'styled-components'
import { SansText } from '@velasca/ui/sans-text'
import { SerifTitle } from '@velasca/ui/serif-title'

export const Container = styled.div`
  max-width: var(--container-max-width);
  margin: 0 auto;
  margin-top: 1rem;
`

export const Header = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  margin-bottom: 2rem;
  height: 8rem;
`

export const Quote = styled.div`
  width: 0.4rem;
  height: 100%;
  background: ${({ theme }) => theme.colors.primary};
`

export const HeaderTitles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;

  ${SansText} {
    margin: 0;
  }

  ${SerifTitle} {
    text-transform: capitalize;
  }
`
